import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/Home' },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../components/Home'),
  },
  {
    path: "/ProductCenter",
    name: 'ProductCenter',
    component: () => import('../components/ProductCenter')
  },
  {
    path: "/EnvironmentalSanitation",
    name: 'EnvironmentalSanitation',
    component: () => import('../components/EnvironmentalSanitation')
  },
  {
    path: "/ScopeOfServices",
    name: 'ScopeOfServices',
    component: () => import('../components/ScopeOfServices')
  },
  {
    path: "/SmartSanitation",
    name: 'SmartSanitation',
    component: () => import('../components/SmartSanitation')
  },
  {
    path: "/NewsAndInformation",
    name: 'NewsAndInformation',
    component: () => import('../components/NewsAndInformation')
  },
  {
    path: "/AboutBaoCheng",
    name: 'AboutBaoCheng',
    component: () => import('../components/AboutBaoCheng')
  },
  {
    path: "/NavigationBar",
    name: 'NavigationBar',
    component: () => import('../views/nav/NavigationBar')
  },
  {
    path: "/NavigationBar2",
    name: 'NavigationBar2',
    component: () => import('../views/nav/NavigationBar2')
  },
  {
    path: "/serchProduct",
    name: 'serchProduct',
    component: () => import('../views/searchProduct/serchProduct')
  },
  {
    path: "/BrandProducts",
    name: 'BrandProducts',
    component: () => import('../views/BrandProducts/BrandProducts')
  },
  {
    path: "/ProductList",
    name: 'ProductList',
    component: () => import('../views/ProductList/ProductList'),
    children: [
      {
        path: 'Sidebar',
        name: "Sidebar",
        component: () => import('../views/ProductList/ProductList')
      }, {
        path: 'AllType',
        name: "AllType",
        component: () => import('../views/ProductList/ModelType/AllType')
      }, {
        path: 'Compressor',
        name: "Compressor",
        component: () => import('../views/ProductList/ModelType/Compressor')
      }, {
        path: 'EnvironmentalSanitationCar',
        name: "EnvironmentalSanitationCar",
        component: () => import('../views/ProductList/ModelType/EnvironmentalSanitationCar')
      }, {
        path: 'EnvironmentalSanitationEquipment',
        name: "EnvironmentalSanitationEquipment",
        component: () => import('../views/ProductList/ModelType/EnvironmentalSanitationEquipment')
      }
    ]
  }, {
    path: "/BottomArea",
    name: 'BottomArea',
    component: () => import('../views/footer/BottomArea')
  },
  {
    path: "/details",
    name: 'details',
    component: () => import('../views/details/details')
  },
  {
    path: "/newsDetails",
    name: 'newsDetails',
    component: () => import('../views/newsDetails/newsDetails')
  },
]
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  base: '/',
  mode: 'hash',
  routes,
})

export default router